/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Pageable } from './Pageable';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
} from './Pageable';
import type { Sort } from './Sort';
import {
    SortFromJSON,
    SortFromJSONTyped,
    SortToJSON,
} from './Sort';
import type { ZoneDTO } from './ZoneDTO';
import {
    ZoneDTOFromJSON,
    ZoneDTOFromJSONTyped,
    ZoneDTOToJSON,
} from './ZoneDTO';

/**
 * 
 * @export
 * @interface ZonePageDTO
 */
export interface ZonePageDTO {
    /**
     * 
     * @type {Array<ZoneDTO>}
     * @memberof ZonePageDTO
     */
    content?: Array<ZoneDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof ZonePageDTO
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ZonePageDTO
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ZonePageDTO
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof ZonePageDTO
     */
    numberOfElements?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof ZonePageDTO
     */
    pageable?: Pageable;
    /**
     * 
     * @type {number}
     * @memberof ZonePageDTO
     */
    size?: number;
    /**
     * 
     * @type {Sort}
     * @memberof ZonePageDTO
     */
    sort?: Sort;
    /**
     * 
     * @type {number}
     * @memberof ZonePageDTO
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof ZonePageDTO
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the ZonePageDTO interface.
 */
export function instanceOfZonePageDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ZonePageDTOFromJSON(json: any): ZonePageDTO {
    return ZonePageDTOFromJSONTyped(json, false);
}

export function ZonePageDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ZonePageDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': !exists(json, 'content') ? undefined : ((json['content'] as Array<any>).map(ZoneDTOFromJSON)),
        'first': !exists(json, 'first') ? undefined : json['first'],
        'last': !exists(json, 'last') ? undefined : json['last'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'pageable': !exists(json, 'pageable') ? undefined : PageableFromJSON(json['pageable']),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'sort': !exists(json, 'sort') ? undefined : SortFromJSON(json['sort']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
    };
}

export function ZonePageDTOToJSON(value?: ZonePageDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content === undefined ? undefined : ((value.content as Array<any>).map(ZoneDTOToJSON)),
        'first': value.first,
        'last': value.last,
        'number': value.number,
        'numberOfElements': value.numberOfElements,
        'pageable': PageableToJSON(value.pageable),
        'size': value.size,
        'sort': SortToJSON(value.sort),
        'totalElements': value.totalElements,
        'totalPages': value.totalPages,
    };
}

